module.exports = __webpack_public_path__ + "img/Treat_item_syringe_icon.6aeff7a5.svg";